import CardRow from '../../ui/CardRow';
import Badge from '../../ui/Badge';
import ActionMenu from '../../ui/ActionMenu';
import { formatDateTime } from '../../utils/formatDateTime';
import { getRoleLabel, getStatusLabel } from '../../utils/labels';

const shortId = (id) => (id ? String(id).slice(0, 8) : '');

const roleVariant = (role) => {
  if (role === 'superadmin') return 'primary';
  if (role === 'admin') return 'primary';
  return 'neutral';
};

const statusBadge = (isActive, t) => (
  <Badge variant={isActive ? 'success' : 'warning'}>
    {getStatusLabel(isActive, t)}
  </Badge>
);

export default function UserRowCard({ user, t, onAction }) {
  const actions = [
    { key: 'viewDetails', label: t('actions.viewDetails') || 'Ver detalles', onClick: () => onAction('viewDetails') },
    { key: 'role', label: t('users.changeRole') || 'Cambiar rol', onClick: () => onAction('changeRole') },
    { key: 'reset', label: t('users.resetPassword'), onClick: () => onAction('resetPassword') },
    { type: 'divider' },
    {
      key: 'status',
      label: user.isActive ? t('users.deactivate') : t('users.activate'),
      onClick: () => onAction('toggleStatus'),
      variant: user.isActive ? 'danger' : undefined
    },
    { type: 'divider' },
    { key: 'delete', label: t('users.delete'), onClick: () => onAction('delete'), variant: 'danger' }
  ];

  return (
    <CardRow
      columns={[
        <div>
          <div className="ui-headline">{user.name || '—'}</div>
          <div className="ui-subtext">{user.email || '—'}</div>
        </div>,
        <div>
          <div className="ui-subtext">{t('users.organization')}</div>
          <div>{user.organizationName || '—'}</div>
          <div className="ui-subtext">
            {user.organizationAdminEmail || shortId(user.organizationId) || '—'}
          </div>
        </div>,
        <div>
          <div className="ui-subtext">{t('users.role')}</div>
          <Badge variant={roleVariant(user.role)}>{getRoleLabel(user.role, t, user.isOwner)}</Badge>
        </div>,
        <div>
          <div className="ui-subtext">{t('users.active')}</div>
          {statusBadge(user.isActive, t)}
        </div>,
        <div>
          <div className="ui-subtext">{t('users.createdAt')}</div>
          <div>{user.createdAt ? formatDateTime(user.createdAt) : '—'}</div>
        </div>
      ]}
      actions={<ActionMenu items={actions} ariaLabel={`Acciones ${user.name || user.email}`} />}
    />
  );
}
